import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const FilterIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="fire-icon"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.75 3.71053C1.75 3.31811 2.07235 3 2.47 3H13.03C13.4276 3 13.75 3.31811 13.75 3.71053C13.75 4.10294 13.4276 4.42105 13.03 4.42105H2.47C2.07235 4.42105 1.75 4.10294 1.75 3.71053ZM3.67 7.5C3.67 7.10759 3.99235 6.78947 4.39 6.78947H11.11C11.5076 6.78947 11.83 7.10759 11.83 7.5C11.83 7.89241 11.5076 8.21053 11.11 8.21053H4.39C3.99235 8.21053 3.67 7.89241 3.67 7.5ZM5.59 11.2895C5.59 10.8971 5.91235 10.5789 6.31 10.5789H9.19C9.58764 10.5789 9.91 10.8971 9.91 11.2895C9.91 11.6819 9.58764 12 9.19 12H6.31C5.91235 12 5.59 11.6819 5.59 11.2895Z"
      fill="currentColor"
    />
  </Icon>
);
